export default __webpack_public_path__ + "static/media/mirror.01b69e27.png";